module.exports = __webpack_public_path__ + "fonts/Inter-400-cyrillic-ext25.47734ae.woff2";